<section>
    <div class="main">
        <h1>Thank You</h1>
        <h2>For Choosing Zebaish</h2>
        <h3>Your Order is Posted</h3>
        <p>You can track your order in Profile setting's Order tab</p>
        <p>We have sent you an email confirming your order and you might also recieve a call regarding your order</p>
        <h3>Happy Renting!</h3>
    </div>
</section>